import { createSlice } from "@reduxjs/toolkit";
import { getOtherAppications } from "../reduxApi/OtherApplicationReduxApi";

const otherApplicationSlice = createSlice({
    name: 'otherApplication',
    initialState: {
        status: 'idel',
        isFiltered: false,
        otherApplication: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteOtherApplicationAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.otherApplication.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.otherApplication.splice(index, 1);
                }
            });
        },
        updateOtherApplicationAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.otherApplication.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.otherApplication.splice(index, 1,  action.payload)
            }
        },
        addOtherApplicationAction: (state, action) => {
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.otherApplication.unshift({ temp });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getOtherAppications.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getOtherAppications.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.otherApplication = action.payload.data.otherApplicationMasters;
            })
    }
})
export const { deleteOtherApplicationAction, updateOtherApplicationAction, addOtherApplicationAction,setFilteredStatus } = otherApplicationSlice.actions
export default otherApplicationSlice.reducer